import { curry, flowRight } from "lodash";
import type { SavedSearchesCellProps } from "app/pages/sales-intelligence/pages/home/configuration/table-columns/saved-searches/types";
import withTrackedRedirectCell from "app/pages/sales-intelligence/pages/home/hoc/withTrackedRedirectCell";
import { homePageQueryKeys } from "app/pages/sales-intelligence/pages/home/services/queries/queryKeyFactory";
import type { QueryKey } from "@tanstack/react-query";
import withQueryDataCell from "../../../hoc/withQueryDataCell";

const getSavedSearchesAssetsCountQueryKey = (props: SavedSearchesCellProps): QueryKey => {
    return homePageQueryKeys.savedSearchesCounts(props.row.searchId);
};

const withAssetsCountQueryData = curry(withQueryDataCell)(getSavedSearchesAssetsCountQueryKey);

export const createSavedSearchesCell = flowRight(withAssetsCountQueryData, withTrackedRedirectCell);
